module.exports = __webpack_public_path__ + "img/1.746cd71f.png";